import React from 'react';

const MONTHS = [
    { 
        numeric: '01',
        label: 'January' 
    },
    { 
        numeric: '02',
        label: 'February' 
    },
    { 
        numeric: '03',
        label: 'March' 
    },
    { 
        numeric: '04',
        label: 'April' 
    },
    { 
        numeric: '05',
        label: 'May' 
    },
    { 
        numeric: '06',
        label: 'June' 
    },
    { 
        numeric: '07',
        label: 'July' 
    },
    { 
        numeric: '08',
        label: 'August' 
    },
    { 
        numeric: '09',
        label: 'September' 
    },
    { 
        numeric: '10',
        label: 'October' 
    },
    { 
        numeric: '11',
        label: 'November' 
    },
    { 
        numeric: '12',
        label: 'December' 
    },
]

const MONTHS_AS_OPTIONS = MONTHS.map(entry => (
    <option key={entry.numeric} value={entry.numeric}>{entry.label}</option>
));

export {
    MONTHS,
    MONTHS_AS_OPTIONS,
}


// WEBPACK FOOTER //
// ./src/components/billing-form/constants/months.js